


















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {CropType, isUndefined, getCropTypeColor} from "@/constants/crop-type";
import { Analysis } from "@/api/analyses/types";
import { FarmAnalysisResult } from "@/api/results/types";
import { formattedAreaInHa } from "@/filters/area";
import { percentFilter, percentAsIsFilter } from "@/filters/percent";
import { formattedYield, formattedProduction } from "@/filters/yield";
import { roundedWithFrac } from "@/filters/scalar";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import i18n from "@/i18n";

@Component({
  name: "GeneralSummary",
  components: {
    AgroIcons,
  },
  computed: {
    CropType() {
      return CropType
    }
  },
  filters: {
    formattedAreaInHa,
    formattedYield,
    formattedProduction,
    percentFilter,
    percentAsIsFilter,
    roundedWithFrac,
    formattedDate(value: Date) {
      if (!value) {
        return "";
      } else {
        const dateAux = new Date(value);
        dateAux.setUTCMinutes(
          dateAux.getUTCMinutes() + dateAux.getTimezoneOffset()
        );
        return i18n.d(dateAux, "short");
      }
    },
  },
})
export default class ResultSummary extends Vue {
  @Prop({ type: Array, required: true })
  private results!: FarmAnalysisResult[];

  @Prop({ type: Object, required: true })
  private analysis!: Analysis;

  @Prop({ type: String, required: false, default: '' })
  private harvestSeason!: string;

  private anyTypeVisible = true;
  private allCropsVisible = true;
  private getCropTypeColor = getCropTypeColor;
  
  @Watch('allCropsVisible') 
  private onAllCropsVisibleChange() {
    this.anyTypeVisible = this.allCropsVisible;
    this.results.forEach(it => it.visible = this.allCropsVisible);
  }
  
  private emitShowPlots(cropTypes: String[], visible: boolean) {
    this.$emit('show-plots', {'cropTypes': cropTypes, 'visible': visible });
  }
  
  get cropResults() {
    return this.results.filter(it => !isUndefined(it.cropType));
  }

  get effectiveHarvestSeason(): string {
    return this.harvestSeason || this.analysis.harvestSeason;
  }

  get harvestSeasonLabel(): string {
    return this.analysis.unified
      ? this.$t('result-summary.displayed-harvest') as string
      : this.$t('result-summary.harvest-season') as string;
  }

  get harvestSeasonValue(): string {
    return this.analysis.unified
      ? this.$t(`harvest-season-unified.${this.effectiveHarvestSeason}`) as string
      : this.$t(`harvest-season.${this.effectiveHarvestSeason}`) as string;
  }

  getArablePercentage(result: FarmAnalysisResult) {
    return this.analysis.farmArea
      ? result.arableArea / this.analysis.farmArea
      : 0.0;
  }

  getCropPercentage(cropArea: number) {
    return this.analysis.farmArea
      ? cropArea / this.analysis.farmArea
      : 0.0;
  }

  get noCropArea() {
    return this.results
      .filter(it => isUndefined(it.cropType))
      .map(it => it.cropArea)
      .reduce((a, b) => a + b, 0);
  }

}
